import { ADD_PEDIDOS, UPDATE_PEDIDO, CLEAR_PEDIDOS } from '../actions/actionTypes';

const initialState = {
    pedidos: {},
};

export const pedidoReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_PEDIDOS:
            return [...action.pedidos];
        case UPDATE_PEDIDO:
            const pedidos = state.filter(e => !(e.EBELN === action.pedido.EBELN && e.COR === action.pedido.COR));
            let pedidosAlterados = state.filter(e => e.EBELN === action.pedido.EBELN && e.COR === action.pedido.COR);
            pedidosAlterados = pedidosAlterados.map(
                e =>
                    (e = {
                        ...e,
                        STATUS_AUDITORA: action.pedido.STATUS_AUDITORA || e.STATUS_AUDITORA,
                        OBS: action.pedido.OBS || e.OBS,
                        DTAUD: action.pedido.DTAUD || e.DTAUD,
                        DATA_APROV: action.pedido.DATA_APROV || e.DATA_APROV,
                        STATUS_APROV: action.pedido.STATUS_APROV || e.STATUS_APROV,
                        QMNUM: action.pedido.QMNUM || e.QMNUM,
                    })
            );
            return [...pedidos, ...pedidosAlterados];
        case CLEAR_PEDIDOS:
            return [];
        default:
            return state;
    }
};
